import { apiClient } from './api-client';

/**
 * Best-effort reconciliation of coupon redemptions from recent Shopify orders.
 * Order webhooks need Shopify "protected customer data" approval, so the
 * dashboards trigger this on load instead. Failures are swallowed so a sync
 * problem never blocks the page from rendering its data.
 */
export async function syncOrdersQuietly(): Promise<void> {
  try {
    await apiClient.post('/coupons/sync-orders');
  } catch {
    /* best-effort — ignore */
  }
}
